var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-textarea", {
        attrs: {
          placeholder: _vm.$t("observations-ph"),
          rows: 3,
          maxRows: 9,
          readOnly: _vm.historyReadOnly
        },
        model: {
          value: _vm.observations,
          callback: function($$v) {
            _vm.observations = $$v
          },
          expression: "observations"
        }
      }),
      _vm._v(" "),
      !_vm.historyReadOnly
        ? _c("base-button", { on: { click: _vm.saveObservations } }, [
            _vm._v(_vm._s(_vm.$t("save-btn")))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6b4ffd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6b4ffd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryObservationsSection.vue
// module id = 3944
// module chunks = 32